import React, { Component } from "react";
import "./print.scss";

class CallToActionJune extends Component {
  formatPhoneWithDots = (mobilePhoneNo) => {
    const phoneStr = String(mobilePhoneNo || "").replace(/\D/g, "");

    if (phoneStr.length < 10) {
      return phoneStr ? <div className="phone-num-row">{phoneStr}</div> : null;
    }

    return (
      <div className="phone-num-row">
        {phoneStr.slice(0, 3)}
        <div className="phone-circle-divider" />
        {phoneStr.slice(3, 6)}
        <div className="phone-circle-divider" />
        {phoneStr.slice(6)}
      </div>
    );
  };

  render() {
    const { agentData, useDoubleNumbers, currentArea } = this.props;
    const { mlsAreaID } = currentArea;
    const { mobilePhoneNo, teamMembers, listgenUserID, isMemberOfTeam } =
      agentData || {};
    let callToActionText = "Next Step, Personally Guided";
    if (listgenUserID === "109818") {
      callToActionText = "Your Lafayette Real Estate Resource";
    }
    let callToActionTextStyles;
    if (callToActionText.length > 32) {
      callToActionTextStyles = "call-to-action-text-26";
    }
    let useTeamMemberPhone = false;
    if (
      (listgenUserID === "115901" || listgenUserID === "114383") &&
      isMemberOfTeam &&
      teamMembers &&
      teamMembers.length > 1
    ) {
      useTeamMemberPhone = true;
    }
    const phoneDisplay = useTeamMemberPhone
      ? this.formatPhoneWithDots(teamMembers[1].phone)
      : this.formatPhoneWithDots(mobilePhoneNo);

    if (useDoubleNumbers) {
      return (
        <div className="print-call-to-action-june double-numbers-container">
          <div className="print-call-to-action-june-text">
            <p className={callToActionTextStyles}>{callToActionText}</p>
          </div>
          {phoneDisplay && (
            <div className="print-double-call-to-action-june-phone double-number-1">
              {phoneDisplay}
            </div>
          )}
          {teamMembers && teamMembers.length > 1 && (
            <div className="print-double-call-to-action-june-phone double-number-2">
              {this.formatPhoneWithDots(teamMembers[1].phone)}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="print-call-to-action-june">
          <div className="print-call-to-action-june-text">
            <p className={callToActionTextStyles}>{callToActionText}</p>
          </div>
          {phoneDisplay && (
            <div className="print-call-to-action-june-phone">
              {phoneDisplay}
            </div>
          )}
        </div>
      );
    }
  }
}

export default CallToActionJune;
